import { render, staticRenderFns } from "./AccuracySurveyFlow.vue?vue&type=template&id=bc45da7c&scoped=true&"
import script from "./AccuracySurveyFlow.vue?vue&type=script&lang=js&"
export * from "./AccuracySurveyFlow.vue?vue&type=script&lang=js&"
import style0 from "./AccuracySurveyFlow.vue?vue&type=style&index=0&id=bc45da7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45da7c",
  null
  
)

export default component.exports